import { BOOKED, REMOVED } from "./actionsTypes";

// initialState
const intitialState = [];

// function to get max id from state
const getMaxId = (state) => {
  return state.reduce((prevId, currentId) => {
    return Math.max(prevId, currentId.id);
  }, 0);
};

const flightReducer = (state = intitialState, action) => {
  switch (action.type) {
    case BOOKED:
      return [
        ...state,
        {
          id: getMaxId(state) + 1,
          ...action.payload,
        },
      ];
    case REMOVED:
      return state.filter((book) => book.id !== action.payload.id);

    default:
      return [...state];
  }
};
export default flightReducer;
